import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IUser } from '../../../ts/ServerApi/types/IUser';

export interface IGetUsersForDataAlertParams extends IGetItemsParams {
  dataAlertId: string;
}

export interface IGetUsersForDataAlertResult extends IGetItemsResult {
  users: IUser[];
}

export class GetUsersForDataAlertRequest extends Request<IGetItemsParams, IGetUsersForDataAlertResult> {
  constructor(params: IGetUsersForDataAlertParams) {
    super('getUsersForDataAlert', params);
  }
}
